import { Building2, Eye, ShieldX, X } from 'lucide-react'

interface TeamPermissionMessageProps {
  onClose: () => void
  variant?: 'viewer' | 'property_limit'
  maxProperties?: number
}

export default function TeamPermissionMessage({ onClose, variant, maxProperties }: TeamPermissionMessageProps) {
  const isViewer = variant === 'viewer'
  const isPropertyLimit = variant === 'property_limit'

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{ background: 'rgba(0, 0, 0, 0.5)' }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm mx-4 rounded-2xl p-6 text-center"
        style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border-color)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
        onClick={e => e.stopPropagation()}
        data-readonly-safe="true"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-1 rounded-lg transition hover:bg-[var(--bg-surface)]"
          style={{ color: 'var(--text-muted)', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <X className="w-4 h-4" />
        </button>

        <div
          className="w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center"
          style={{ backgroundColor: 'rgba(200, 121, 65, 0.12)' }}
        >
          {isPropertyLimit
            ? <Building2 className="w-7 h-7" style={{ color: '#c87941' }} />
            : isViewer
              ? <Eye className="w-7 h-7" style={{ color: '#c87941' }} />
              : <ShieldX className="w-7 h-7" style={{ color: '#c87941' }} />}
        </div>

        <h3 className="text-lg font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
          {isPropertyLimit ? 'Property Limit Reached' : isViewer ? 'View-only access' : 'Permission Required'}
        </h3>
        <p className="text-sm mb-5" style={{ color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          {isPropertyLimit
            ? `Your agency has reached its property limit${maxProperties ? ` (${maxProperties} max)` : ''}. Contact your account owner to upgrade the plan.`
            : isViewer
              ? 'You have view-only access to this account. To request edit permissions, please speak with your agency administrator.'
              : "You don't have permission to perform this action. Contact your agency administrator."}
        </p>

        <button
          onClick={onClose}
          className="px-5 py-2 rounded-lg text-sm font-medium transition hover:opacity-90 cursor-pointer"
          style={{ backgroundColor: 'var(--color-primary, #1a2744)', color: 'white' }}
        >
          OK
        </button>
      </div>
    </div>
  )
}
